import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { signUpModel } from '../../models/signup/signup.model';

@Component({
  selector: 'app-signup',
  templateUrl: './broadcast.component.html'
})
export class broadcastComponent implements OnInit {
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public generalBroadCast : any = [];
  public today : any = new Date().getTime();
  public regeonalBroadCast : any = [];
  public zonalBroadCast : any = [];
  
  constructor(public http: HttpTestService, 
			  public session: sessionServices) { }

  	ngOnInit() {
	  this.getSession();
	  this.getBroadcastData();
	}
  
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}
	
	getBroadcastData = function(){
	 var self = this;
	 var genData = []; 
	 var self = this;
		self.http.getGeneralBroadCast().subscribe(
		(data) => {
			genData = data;
		},
		(error) => {
			self.errorMsg = error;
			self.generalBroadCast = [];
			this.busySpinner.busy = false;
		},
		() => {
				for(var i = 0; i<genData.length; i++){
					if((!genData[i].endDate || genData[i].endDate >= self.today) && (!genData[i].startDate || genData[i].startDate <= self.today) && genData[i].status === 1){
						self.generalBroadCast.push(genData[i]);
					}
				}
			}
		);
	
	if(self.sessionData.sessionStarted && self.sessionData.sessionRegion != ''){	
	var regionName = ((self.sessionData.sessionRegion));
	var regData = [];
	var zoneData = [];
	self.http.getBlroRegionNameWiseBroadcastData(regionName).subscribe(
		(data) => {
		  regData = data;
		  },
		(error) => {
			self.errorMsg = error;
			 self.regeonalBroadCast = [];
		},
		() => {
			for(var i = 0; i<regData.length; i++){
				if((!regData[i].endDate || regData[i].endDate >= self.today)  && (!regData[i].startDate || regData[i].startDate <= self.today) && regData[i].status === 1){
					self.regeonalBroadCast.push(regData[i]);
				}
			}
		}
	);

	self.http.getMouzaZoneWiseBroadcastData(self.sessionData.sessionRegion,self.sessionData.cosumerZone).subscribe(
		(data) => {
			zoneData = data;
		},
		(error) => {
			self.errorMsg = error;
		  self.zonalBroadCast = [];
			},
			() => {
				for(var i = 0; i<zoneData.length; i++){
					if((!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today)  && (!zoneData[i].startDate || zoneData[i].startDate <= self.today) && zoneData[i].status === 1){
						self.zonalBroadCast.push(zoneData[i]);
					}
				}
			});
		}
	}

	// self.http.getZonalBroadCast("ZONE", self.sessionData.cosumerZone)
	// 	  .subscribe(
	// 		(data) => {
	// 		  zoneData = data;
	// 		  },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			 self.zonalBroadCast = [];
	// 		},
	// 		() => {
	// 			for(var i = 0; i<zoneData.length; i++){
	// 				if(!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today){
	// 					self.zonalBroadCast.push(zoneData[i]);
	// 				}
	// 			}
	// 		}
	// );
	
	//  self.http.getGeneralBroadCast()
	// 	  .subscribe(
	// 		(data) => {
	// 		  genData = data;
	// 		  },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			 self.generalBroadCast = [];
	// 		},
	// 		() => {
	// 			for(var i = 0; i<genData.length; i++){
	// 				if(!genData[i].expirationDate || genData[i].expirationDate >= self.today){
	// 					self.generalBroadCast.push(genData[i]);
	// 				}
	// 			}
	// 		}
	// );
	
	//var region = ((self.sessionData.sessionRegion).startsWith("GAYA"))?"GAYA":"ASANSOL";
	// 	var regData = [];
	// 	var zoneData = [];
	// 	self.http.getZonalBroadCast(region)
	// 	  .subscribe(
	// 		(data) => {
	// 		  regData = data;
	// 		  },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			 self.regeonalBroadCast = [];
	// 		},
	// 		() => {
	// 			for(var i = 0; i<regData.length; i++){
	// 				if(!regData[i].expirationDate || regData[i].expirationDate >= self.today){
	// 					self.regeonalBroadCast.push(regData[i]);
	// 				}
	// 			}
	// 		}
	// );
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/broadcast/broadcast.component.ts